// "Buy it now" on the product page: read the form's selected variant and quantity,
// then open a cart permalink (/cart/<variant>:<qty>), which goes straight to checkout.
document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-buy-now]') : null;
  if (!button) return;
  const form = button.closest('form');
  if (!form) return;
  const data = new FormData(form);
  const variantId = data.get('id');
  const quantity = Math.max(1, parseInt(String(data.get('quantity') || '1'), 10) || 1);
  if (!variantId) return;
  const cartUrl = (button.getAttribute('data-cart-url') || '/cart').replace(/\/$/, '');
  window.location.href = `${cartUrl}/${variantId}:${quantity}`;
});
